<div class="login-content full-height">
    <div nz-row nzJustify="space-around" nzAlign="middle">
        <div class="container-logo"><img src="../../../../assets/images/logo.png" class="img-login-logo responsive" /></div>
        <div style="display:flex; flex-direction: column; align-items: center; justify-content: center; margin-top: 140px;">
            <ng-template #indicatorTemplate><i nz-icon nzType="sync" [nzSpin]="true" nzTheme="outline" style="font-size: 128px; color: rgb(54, 154, 255);"></i></ng-template>
            <nz-spin nzSimple [nzIndicator]="indicatorTemplate"></nz-spin>
            <p class="loading-msg">Authenticating...</p>
        </div>
    </div>
</div>

<nz-footer class="fixed-bottom">
    <div nz-row nzJustify="space-between" nzAlign="bottom">
        <p id="footer_login" class="text-center">Copy Right © 2020. Bina Nusantara University - All Rights Reserved</p>
    </div>
</nz-footer>